<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <ValidatableTextField v-model:form="form" label="Reason for Change" :field="'reason_for_change'" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import type { IPropertyVersion } from '@app/land-hold/property/models/PropertyVersion';
import { usePropertyRepository } from '@app/land-hold/property/repositories/usePropertyRepository';
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';

const props = defineProps({
    item: {
        type: Object as PropType<IPropertyVersion>,
        required: true,
    },
    propertyId: {
        type: String,
        required: true,
    },
});

const update = usePropertyRepository().command.updateVersionReason(props.propertyId, props.item.id, {
    reason_for_change: props.item.reason_for_change,
});
const form = update.form;
useInjectSubmitForm(update.execute);
</script>
